import { useFeatureFlagVariantKey } from '@posthog/react'
import { useContext } from 'react'
import { featureFlagDefaults, type RuntimeFeatureFlag } from './definitions'
import { FeatureFlagLoadState, FeatureFlagLoadStateContext } from './context'
import { recordFeatureFlag } from './sentry'

/** Subscribe to backend-supplied SDK values, with an explicit fallback before a decision arrives. */
export function useRuntimeFeatureFlag(flag: RuntimeFeatureFlag): { enabled: boolean; loading: boolean } {
  const value = useFeatureFlagVariantKey(flag)
  const loadState = useContext(FeatureFlagLoadStateContext)
  const enabled = typeof value === 'boolean' ? value : featureFlagDefaults[flag] ?? false
  const loading = loadState === FeatureFlagLoadState.LOADING
  // Record at evaluation so an error rendering the newly enabled feature carries its decision.
  if (!loading) recordFeatureFlag(flag, enabled)
  return { enabled, loading }
}
